import { ReactNode } from 'react'
import { PageLayout } from 'Common/Layout/PageLayout'
import { useSettingsContext } from './EditSettings.types'

/**
 * A scenario-settings page: the shell's PageLayout with the scenario it
 * belongs to as the subtitle (override with `subtitle`).
 */
export const SettingsPage = ({
  title,
  subtitle,
  status,
  actions,
  children,
}: {
  title: string
  subtitle?: string
  status?: ReactNode
  actions?: ReactNode
  children?: ReactNode
}) => {
  const { state } = useSettingsContext()

  return (
    <PageLayout
      title={title}
      subtitle={subtitle ?? (state.selectedScenario || undefined)}
      status={status}
      actions={actions}
    >
      {children}
    </PageLayout>
  )
}
